import React, { Suspense, useEffect, memo } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";

import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import TabNavigation from "./components/layout/TabNavigation";
import FloatingWhatsApp from "./components/layout/Floatingwhatsapp";
import AppRoutes from "./components/routing/AppRoutes";
import "./styles/responsive.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Header />
        <TabNavigation />
        <ScrollToTop />
        <div style={{ flex: 1 }}>
          <Suspense fallback={<div style={{ textAlign: "center", padding: "2rem" }}>Loading...</div>}>
            <AppRoutes />
          </Suspense>
        </div>
        <Footer />
        <FloatingWhatsApp />
      </div>
    </Router>
  );
}

export default memo(App);
